import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PhonelinkEraseOutlinedIcon from "@mui/icons-material/PhonelinkEraseOutlined";

import { useNavigateWithClient } from "hooks";

import MobileAppShell from "../layout/MobileAppShell";

/**
 * 404 fallback for any route not available on mobile (unbuilt / desktop-only
 * features + genuinely unknown paths). As each feature ships, add its <Route/>
 * in `mobile/index.jsx` and it stops landing here.
 */
export default function NotAvailable() {
  const navigateWithClient = useNavigateWithClient();

  return (
    <MobileAppShell title="">
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 6,
          gap: 3,
        }}
      >
        <PhonelinkEraseOutlinedIcon
          sx={{ fontSize: 64, color: "primary.clr-200" }}
        />
        <Typography
          color="neutral.clr-300"
          sx={{ fontSize: 64, fontWeight: 700, lineHeight: 1 }}
        >
          404
        </Typography>
        <Typography variant="h5-semiBold" color="neutral.clr-800">
          Page not found
        </Typography>
        <Typography variant="body02-regular" color="neutral.clr-500">
          The page you&apos;re looking for doesn&apos;t exist or isn&apos;t
          available.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigateWithClient("/home")}
          sx={{ mt: 2, borderRadius: 60, px: 6 }}
        >
          Back to Dashboard
        </Button>
      </Box>
    </MobileAppShell>
  );
}
